<div class="actionItem-component" style="margin: 0 20px;">
  <div style="display: flex; flex-direction: row; margin: 16px 0 20px 0; align-items:center;" *ngIf="isEditable">
    <button mat-raised-button
            (click)="editSet(null)"
            style="border-radius: 6px;margin-right: 10px; "
            class="button">
      Create
    </button>
  </div>
  <div style="display: flex; flex-direction: row; gap: 40px;">
    <div style="width: 100%;">
      <p-table [value]="actionItemSets"
               *ngIf="actionItemSets"
      dataKey="id">
        >
        <ng-template pTemplate="body" let-set let-expanded="expanded">
          <tr [pRowToggler]="set">
            <td style="width: 10em;">
              <a>
                <i [ngClass]="expanded ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
              </a>
            </td>
            <td>{{set.name}}</td>
            <td style="width: 10em;">
              <i class="pi pi-pencil cursor-pointer" (click)="editSet(set)"></i>
              <i class="pi pi-trash cursor-pointer" (click)="deleteSet(set)"></i>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="expandedrow" let-set let-rowIndex="rowIndex" let-expanded="expanded">
          <tr>
            <td colspan="3">
              <div style="display: flex; flex-direction: row; margin: 16px 0 20px 0; align-items:center;" *ngIf="isEditable">
                <button mat-raised-button
                        (click)="add(set)"
                        style="border-radius: 6px;margin-right: 10px; "
                        class="button">
                  Create
                </button>

                <button mat-raised-button matTooltip="{{this.constants.ATTACHMENT_FILE_DESCRIPTION}}"
                        (click)="inputFile.click()">
                  <i class="pi pi-paperclip"></i>
                  Upload Items
                </button>
                <input #inputFile
                       type="file"
                       accept="{{this.constants.ATTACHMENT_FILE_EXTENSIONS}}"
                       (change)="uploadItems($event, set)"
                       [style.display]="'none'">

              </div>
            </td>
          </tr>
          <tr>
            <td colspan="3">
              <p-table [value]="set.actionItemForms" [(selection)]="set.selectedItems"
                       *ngIf="set.actionItemForms && rowGroupMetadata[set.id]"
                       rowGroupMode="subheader"
                       dataKey="value.originalCategory">
                >
                <ng-template pTemplate="header">
                  <tr style="white-space: nowrap;font-weight: bold">
                    <th style="width:2em;"></th>
                    <th style="width:20%;">Category</th>
                    <th>Name</th>
                    <th>Project</th>
                    <th>Assigned</th>
                    <th style="width:15em"><i class="pi pi-trash" mwlConfirmationPopover [title]="'Delete Action Items'"
                                              [popoverMessage]="'You are going to delete all default Action Items. Are you sure?'"
                                              [appendToBody]="true"
                                              [confirmText]="'Yes'" [cancelText]="'No'" placement="left"
                                              (confirm)="dropAllActionItems(set)"></i></th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-item let-rowIndex="rowIndex" let-expanded="expanded"
                             let-columns="columns">
                  <tr class="ui-widget-header"
                      *ngIf="rowGroupMetadata[set.id][item.value.originalCategory || ' '].index === rowIndex">
                    <td colspan="5">
                      <a href="#" [pRowToggler]="item">
                        <i
                          [ngClass]="expanded ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
                        <span>{{ item.value.category }}</span>
                      </a>
                    </td>
                    <td style="width: 5em;">
                      <i class="pi pi-trash" mwlConfirmationPopover [title]="'Delete Action Item'"
                         [popoverMessage]="'You are going to delete these Action Items. Are you sure?'"
                         [appendToBody]="true"
                         [confirmText]="'Yes'" [cancelText]="'No'" placement="left"
                         (confirm)="dropActionItems(set, item.value.category)"></i></td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="expandedrow" let-item let-i="rowIndex">
                  <tr>
                    <td style="width:5em;">
                    <span>
                      <i [ngClass]="item.open ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                         (click)="item.open = !item.open"></i>
                    </span>
                    </td>
                    <td>{{ item.value.category }}</td>
                    <td>{{ item.value.name }}</td>
                    <td>{{ projectsMap[item.value.projectId] }}</td>
                    <td>{{ item.value.assignedTo }}</td>
                    <td style="width: 5em;">
                      <i class="pi pi-trash" mwlConfirmationPopover [title]="'Delete Action Item'"
                         [popoverMessage]="'You are going to delete this Action Item. Are you sure?'"
                         [appendToBody]="true"
                         [confirmText]="'Yes'" [cancelText]="'No'" placement="left"
                         (confirm)="dropActionItem(item)"></i></td>
                  </tr>
                  <tr *ngIf="item.open">
                    <td colspan="6">

                      <form [formGroup]="set.actionItemForms[i]" style="width: 100%;">
                        <div>
                          <mat-checkbox formControlName="isAllOverride">
                            Override All Fields
                          </mat-checkbox>
                        </div>
                        <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: start; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;"
                              class="header">
                          <div style="flex:49%">
                            <mat-form-field class="description-form">
                              <mat-label>Category</mat-label>
                              <input matInput
                                     type="text"

                                     class="form-control"
                                     name="category"
                                     formControlName="category"
                              />
                            </mat-form-field>
                          </div>
                        </div>
                        <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: start; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;"
                              class="header">
                          <div style="flex:49%">
                            <mat-form-field class="description-form">
                              <mat-label>Name</mat-label>
                              <input matInput
                                     type="text"

                                     class="form-control"
                                     name="name"
                                     formControlName="name"
                              />
                            </mat-form-field>
                          </div>
                        </div>
                        <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: start; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;"
                              class="header">
                          <div style="flex:49%">
                            <mat-form-field class="description-form">
                              <mat-label>Description</mat-label>
                              <textarea matInput
                                        cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                                        cdkAutosizeMinRows="1"
                                        cdkAutosizeMaxRows="10"
                                        type="text"

                                        class="form-control"
                                        name="weaknessDescription"
                                        formControlName="weaknessDescription"
                              >
                            </textarea>
                            </mat-form-field>
                          </div>
                        </div>
                        <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;"
                        >
                          <div style="flex:49%">
                            <mat-form-field class="description-form">
                              <mat-label>How Identified</mat-label>
                              <textarea matInput
                                        cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                                        cdkAutosizeMinRows="1"
                                        cdkAutosizeMaxRows="10"
                                        type="text"

                                        class="form-control"
                                        name="howIdentified"
                                        formControlName="howIdentified"
                              >
                          </textarea>
                            </mat-form-field>
                          </div>
                          <div style="flex:2%"></div>
                          <div style="flex:49%" *ngIf="set.actionItemForms[i].controls.isAllOverride.value">
                            <mat-form-field class="example-full-width" style="width:100%;">
                              <mat-label>Responsible Party</mat-label>
                              <input matInput

                                     name="responsibleParty"
                                     formControlName="responsibleParty"
                                     required>
                            </mat-form-field>
                          </div>
                        </div>

                        <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;"
                             >

                          <div style="flex:25%" *ngIf="set.actionItemForms[i].controls.isAllOverride.value">
                            <mat-form-field>
                              <mat-label>Date of Identification</mat-label>
                              <input matInput
                                     [matDatepicker]="identificationDatePicker"

                                     name="identificationDate"
                                     formControlName="identificationDate"
                                     required>

                              <mat-datepicker-toggle matSuffix [for]="identificationDatePicker"></mat-datepicker-toggle>
                              <mat-datepicker #identificationDatePicker></mat-datepicker>
                            </mat-form-field>
                          </div>

                          <div style="flex:2%" *ngIf="set.actionItemForms[i].controls.isAllOverride.value"></div>

                          <div style="flex:25%" *ngIf="set.actionItemForms[i].controls.isAllOverride.value">
                            <mat-form-field>
                              <mat-label>Scheduled Completion Date</mat-label>
                              <input matInput
                                     [matDatepicker]="scheduledCompletionDatePicker"

                                     name="scheduledCompletionDate"
                                     formControlName="scheduledCompletionDate"
                                     required>

                              <mat-datepicker-toggle matSuffix
                                                     [for]="scheduledCompletionDatePicker"></mat-datepicker-toggle>
                              <mat-datepicker #scheduledCompletionDatePicker></mat-datepicker>
                            </mat-form-field>
                          </div>

                          <div style="flex:2%" *ngIf="set.actionItemForms[i].controls.isAllOverride.value"></div>

                          <div style="flex:25%" *ngIf="set.actionItemForms[i].controls.isAllOverride.value">
                            <mat-form-field>
                              <mat-label>Actual Completion Date</mat-label>
                              <input matInput
                                     [matDatepicker]="actualCompletionDatePicker"

                                     name="actualCompletionDate"
                                     formControlName="actualCompletionDate"
                              >

                              <mat-datepicker-toggle matSuffix
                                                     [for]="actualCompletionDatePicker"></mat-datepicker-toggle>
                              <mat-datepicker #actualCompletionDatePicker></mat-datepicker>
                            </mat-form-field>
                          </div>

                          <div style="flex:2%" *ngIf="set.actionItemForms[i].controls.isAllOverride.value"></div>

                          <div style="flex:25%" *ngIf="set.actionItemForms[i].controls.isAllOverride.value">

                            <mat-form-field>
                              <mat-label>Current Status</mat-label>
                              <mat-select
                                formControlName="currentStatus"
                              >
                                <mat-option [value]="0">Not Started</mat-option>
                                <mat-option [value]="1">In-Progress</mat-option>
                                <mat-option [value]="2">Resolved</mat-option>
                                <mat-option [value]="3">Awaiting Review</mat-option>
                                <mat-option [value]="4">Reviewed - Not POAM</mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>

                          <div style="flex:2%" *ngIf="set.actionItemForms[i].controls.isAllOverride.value"></div>

                          <div style="flex:25%">
                            <mat-form-field>
                              <mat-label>Risk Level</mat-label>
                              <mat-select
                                formControlName="riskLevel"
                              >
                                <mat-option [value]="'High'">High</mat-option>
                                <mat-option [value]="'Medium'">Medium</mat-option>
                                <mat-option [value]="'Low'">Low</mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>

                        </div>
                        <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;"
                              *ngIf="set.actionItemForms[i].controls.isAllOverride.value">
                          <mat-form-field class="description-form">
                            <mat-label>Remediation Plans, Actions and Milestones</mat-label>
                            <textarea matInput
                                      cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                                      cdkAutosizeMinRows="1"
                                      cdkAutosizeMaxRows="10"
                                      type="text"

                                      class="form-control"
                                      name="remediationPlansActionsMilestones"
                                      formControlName="remediationPlansActionsMilestones"
                                      required>
                              </textarea>
                          </mat-form-field>
                        </div>

                        <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;"
                              *ngIf="set.actionItemForms[i].controls.isAllOverride.value">
                          <mat-form-field class="description-form">
                            <mat-label>Changes to Remediation Plans, Actions, and Milestones (if applicable)</mat-label>
                            <textarea matInput
                                      cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                                      cdkAutosizeMinRows="1"
                                      cdkAutosizeMaxRows="10"
                                      type="text"

                                      class="form-control"
                                      name="changesToRemediationPlansActionsMilestones"
                                      formControlName="changesToRemediationPlansActionsMilestones"
                            >
                              </textarea>
                          </mat-form-field>
                        </div>

                        <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;"
                              *ngIf="set.actionItemForms[i].controls.isAllOverride.value">
                          <mat-form-field class="description-form">
                            <mat-label>Comments</mat-label>
                            <textarea matInput
                                      cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                                      cdkAutosizeMinRows="1"
                                      cdkAutosizeMaxRows="10"
                                      type="text"

                                      class="form-control"
                                      name="comments"
                                      rows="10" formControlName="comments"

                                      cols="80"
                            >
                              </textarea>
                          </mat-form-field>
                        </div>
                        <div *ngIf="set.actionItemForms[i].controls.isAllOverride.value">
                          <mat-slide-toggle
                            class="example-margin"
                            name="type"
                            formControlName="type"
                          >
                            Visible in POA&M
                          </mat-slide-toggle>
                        </div>
                        <div>
                          <mat-checkbox formControlName="isProtected">
                            Can be modified only from The Vault
                          </mat-checkbox>
                        </div>
                      </form>
                      <button mat-button mat-raised-button style="margin: 10px 0 0 0" (click)="save(set, i)">Save
                      </button>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
